// src/App.js
import React, {useState, useCallback} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Header from './components/Header/Header';
import HomePage from './pages/HomePage';
import Footer from "./components/Footer";
import ProductPage from "./pages/ProductPage";
import CategoryPage from "./pages/CategoryPage";
import {GoogleOAuthProvider} from "@react-oauth/google";
import CartModal from "./components/CartModal/CartModal";
import PaymentPage from "./pages/PaymentPage";
import AdminPage from "./pages/AdminPage";
import CarePage from "./pages/CarePage";
import AboutSeleziumPage from "./pages/AboutSeleziumPage";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PublicOfferAgreementPage from "./pages/PublicOfferAgreementPage";
// import CartPage from './pages/CartPage';
// import ProfilePage from './pages/ProfilePage';

function App() {
    // Стабільна функція getCookie з useCallback
    const getCookie = useCallback((name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? JSON.parse(decodeURIComponent(match[2])) : null;
    }, []);

    const [userData, setUserData] = useState(() => getCookie('userData'));
    const [showCart, setShowCart] = useState(false);

    const openCartModal = () => setShowCart(true);
    const closeCartModal = () => setShowCart(false);

    return (
        <GoogleOAuthProvider clientId="750714848042-rrudcdj2kc5ah3ns8s5drq9sm2cr1vrt.apps.googleusercontent.com">
            <Router>
                <ScrollToTop />
                <Header
                    user={userData}
                    setUser={setUserData}
                    getCookie={getCookie}
                    setShowCart={setShowCart}
                />

                <Routes>
                    {/* Головна сторінка */}
                    <Route path="/" element={<HomePage/>}/>

                    {/* Сторінка про нас */}
                    <Route path="/about-selezium" element={
                        <AboutSeleziumPage 
                            userData={userData}
                            openCartModal={openCartModal}
                        />
                    } />

                    {/* Сторінка догляду за шкірою */}
                    <Route path="/care" element={<CarePage />} />

                    {/* Сторінка політики конфіденційності */}
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

                    {/* Сторінка публічного договору-оферти */}
                    <Route path="/public-offer-agreement" element={<PublicOfferAgreementPage />} />

                    {/* Сторінка чохлів для телефонів */}
                    {/*<Route path="/products/phone-cases" element={<PhoneCasesPage />} />*/}

                    <Route path="/category/:categoryId"
                           element=
                               {
                                   <CategoryPage
                                       userData={userData}
                                       openCartModal={openCartModal}
                                   />
                               }
                    />


                    <Route path="/products/:id"
                           element=
                               {
                                   <ProductPage
                                       userData={userData}
                                       openCartModal={openCartModal}
                                   />
                               }
                    />

                    <Route path="/checkout" element={<PaymentPage userData={userData} />} />
                    
                    {/* Адміністративна панель */}
                    <Route path="/admin/*" element={<AdminPage userData={userData} />} />

                </Routes>
                <Footer/>
            </Router>

            <CartModal
                visible={showCart}
                onClose={closeCartModal}
                userData={userData}
            />
        </GoogleOAuthProvider>
    );
}

export default App;
